import { SourceName } from 'features/application/hooks/useApplicationTrackErrorEvents';
import useUpdateApplication from 'features/application/hooks/useUpdateApplication';
import AddressCollection from 'features/application/screens/AddressCollection/AddressCollection';
import useCustomerApplicationOrigination from 'features/signup/hooks/useCustomerApplicationOrigination';
import React from 'react';

const AddressCollectionWrapper = () => {
  const {
    application,
    fetching,
    error,
    reExecuteQuery,
    hasApplicationLoaded,
    isReapplication,
  } = useCustomerApplicationOrigination({
    sourceName: SourceName.ADDRESS_VERIFICATION,
  });

  const {
    updateApplication,
    updateApplicationResult,
    isUpdateApplicationLoading,
    isUpdateApplicationSuccess,
  } = useUpdateApplication({
    applicationId: application?.id,
    sourceName: SourceName.ADDRESS_VERIFICATION,
  });

  return (
    <AddressCollection
      application={application?.address}
      fetching={fetching}
      error={error as Error}
      isReapplication={isReapplication}
      hasApplicationLoaded={hasApplicationLoaded}
      isUpdateApplicationSuccess={isUpdateApplicationSuccess}
      reExecuteQuery={reExecuteQuery}
      updateApplication={updateApplication}
      updateApplicationResult={updateApplicationResult}
      isUpdateApplicationLoading={isUpdateApplicationLoading}
      nextRoute="/signup/dob"
      backRoute="/signup/personal-information"
    />
  );
};

export default AddressCollectionWrapper;
